import SectionHeading from "./SectionHeading";

const principles = [
  { icon: 'ri-award-line', title: '只推真正值得看完的', desc: '不蹭热度、不堆评分，每一部都经过人工试看与口碑复核。' },
  { icon: 'ri-team-line', title: '听真实观众的声音', desc: '完播率、长评率与二次观看，才是我们最看重的口碑指标。' },
  { icon: 'ri-file-search-line', title: '清单持续更新校准', desc: '片单会随着平台评分与口碑变化定期更新，绝不固步自封。' },
];

const voices = [
  { name: '阿桔', text: '跟着小虎的冷门佳作单刷了十部，没有一部失望，宝藏真的多。', tag: '冷门爱好者' },
  { name: '闻一舟', text: '完结番合集太救命了，周末一口气补完两部，完全不踩雷。', tag: '追更党' },
  { name: '小绿', text: '口碑排行很诚实，是那种真的看完才敢说的话，很安心。', tag: '深度观众' },
];

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="关于小虎"
          title="小虎看番，替你把番海先趟一遍"
          desc="我们是一群把看番当正事做的资深观众。做小虎看番的初心很简单——片单不该是冷冰冰的分数，而是有人替你先看完、再把最值得的那几部递到你面前。"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          <div className="relative min-h-[320px] overflow-hidden rounded-lg bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=cozy%20interior%20of%20a%20night%20viewing%20room%20with%20a%20laptop%20and%20warm%20string%20lights%2C%20anime%20posters%20on%20wall%2C%20snacks%20and%20blankets%2C%20warm%20orange%20mood%20lighting%2C%20stylized%20hand%20painted%20illustration%20evoking%20late%20night%20binge%20watching%20comfort&width=1200&height=900&seq=about-scene&orientation=landscape"
              alt="小虎看番团队：深夜补番观影室"
              title="小虎看番 - 关于我们"
              className="h-full w-full object-cover"
            />
          </div>
          <div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
              {principles.map((p) => (
                <div key={p.title} className="rounded-lg border border-background-200 bg-background-100 p-4">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-background-50">
                    <i className={`${p.icon} text-lg`} />
                  </span>
                  <h4 className="mt-3 font-heading text-base text-foreground-950">{p.title}</h4>
                  <p className="mt-2 text-xs leading-5 text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 space-y-3">
              {voices.map((v) => (
                <figure key={v.name} className="flex gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                    <i className="ri-questionnaire-line text-lg" />
                  </span>
                  <div>
                    <blockquote className="text-sm leading-6 text-foreground-700">“{v.text}”</blockquote>
                    <figcaption className="mt-2 text-xs text-foreground-500">
                      {v.name} · <span className="text-primary-600">{v.tag}</span>
                    </figcaption>
                  </div>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}